module.exports = __webpack_public_path__ + "static/img/1-0.afc5c8ca.webp";